
/**
 * Module dependencies.
 */

import { color } from 'src/styles/utils';
import { css } from 'styled-components';

/**
 * Export `dividerOpacity`.
 */

export const dividerOpacity = 0.15;

/**
 * Export `dividerColor`.
 *
 * `Opacity/White 15` in the design system.
 */

export const dividerColor = color.transparentize('white', dividerOpacity);

/**
 * Export `columnTitleStyles`.
 *
 * `Text/Regular/Semi Bold` in the design system: the heading of every footer
 * column, shared by the desktop columns and the mobile accordion triggers.
 */

export const columnTitleStyles = css`
  color: ${color('white')};
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0;
`;
